const THEATRE_JS_CONFIG = {
  studioEnabled: false,
  projectName: 'intro',
  sheetName: 'Animated scene',
  rate: 1,
  sequencePosition: 0,
}

export { THEATRE_JS_CONFIG };
